import { fieldStyling } from '../../services/vgs/vgsStyling';
import { Style } from './types';

export type FieldError = { fieldName: string; message: string };

export const createField = (
  type: VgsFieldType,
  serializers: VgsSerializer[],
  vgsCollectForm: VGSForm<unknown>,
  ref: React.RefObject<HTMLDivElement>,
  name: string,
  placeholder: string | undefined,
  validations: RegExp[] | undefined,
  style: Style | undefined,
  maskInput: MaskInput | undefined,
): VGSField => {
  if (type === 'file') {
    serializers.push({ name: 'toBase64' });
  }
  const field = vgsCollectForm.field(ref.current, {
    type,
    name,
    placeholder,
    validations: (validations || []).map((v) => `/${v.source}/${v.flags}`),
    serializers,
    css: {
      ...fieldStyling,
      justifyContent: 'center',
      ...style,
    },
  });
  if (type === 'phone') {
    // strip non numerics out
    field.replacePattern('/[^d]+/g');
  }
  if (maskInput) {
    field.mask(maskInput.mask, maskInput.maskChar, maskInput.formatChar);
  }
  return field;
};
